/* eslint-disable react/no-children-prop */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Chaitanya
*/

import React, { useState, useEffect } from 'react';
import * as Layout from '@components/screen/Layout';
import useApi from '@/hooks/useApi';
import SkpInternalBrandBudgetTable from './components/SkpExternalBudgetTable';

import { MsOrder } from '@api/ms-order';

const SkpExternalBudgetTableScreen = (props) => {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  const getAllSkpExternalsBrandBudget = useApi(
    MsOrder.getAllSkpExternalsBrandBudget,
  );

  useEffect(() => {
    let mounted = true;
    if (
      mounted &&
      props?.route?.params?.id &&
      props?.route?.params?.customer_id
    ) {
      getSkpInternalsBrandBudgets(
        props.route.params.id,
        props.route.params.customer_id,
        props.route.params.outlet_id,
      );
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  const getSkpInternalsBrandBudgets = async (
    id,
    customer_id,
    outlet_id = null,
  ) => {
    setLoading(true);
    try {
      const filter = { 'skp_external.id': id, 'customer.id': customer_id };
      if (outlet_id) {
        filter['outlet.id'] = outlet_id;
      }
      const response = await getAllSkpExternalsBrandBudget.request({
        params: { filter },
      });
      if (response?.data?.data && Object.keys(response.data.data).length) {
        const result = response.data.data.map((b) => ({
          ...b,
          initial_budget: b.initial_budget || b.budget_sample,
          initial_dpp: b.initial_dpp || b.dpp,
        }));
        setTableData(result);
      } else {
        setTableData([]);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const isGt = props?.route?.params?.skp_type?.toLowerCase() === 'gt';

  return (
    <Layout.Container testID="skp-external-budget-screen">
      <SkpInternalBrandBudgetTable
        data={tableData}
        loading={loading}
        showLabel={false}
        isGt={isGt}
      />
    </Layout.Container>
  );
};

export default SkpExternalBudgetTableScreen;
